// src/pages/Dashboard/Admin/HeuresEnseignement/components/TeachingHoursMobileCards.jsx

import React from "react";
import { FaCalendarAlt, FaEdit, FaTrash } from "react-icons/fa";

import { formatHours, getTeacherName } from "../utils/teachingHoursUtils";

export default function TeachingHoursMobileCards({
  teachers = [],
  monthSections = [],
  hoursIndex,
  totalsByTeacher = {},
  onEdit,
  onDelete,
  deletingId,
}) {
  return (
    <div className="space-y-4 md:hidden">
      {monthSections.map((section) => (
        <article
          key={`mobile-${section.month}`}
          className="overflow-hidden rounded-2xl border border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-900/60"
        >
          <div className="border-b border-slate-200 bg-slate-50 px-4 py-3 dark:border-slate-800 dark:bg-slate-800/70">
            <p className="text-sm font-bold text-slate-900 dark:text-white">
              {section.label}
            </p>
            <p className="mt-0.5 text-xs text-slate-500 dark:text-slate-400">
              {section.weeks.length} semaine(s)
            </p>
          </div>

          <div className="space-y-3 p-3">
            {section.weeks.map((week) => (
              <div
                key={`mobile-${section.month}-${week}`}
                className="rounded-2xl border border-slate-200 bg-slate-50 p-3 dark:border-slate-800 dark:bg-slate-800/40"
              >
                <div className="mb-3 flex items-center gap-2 text-sm font-bold text-slate-900 dark:text-white">
                  <FaCalendarAlt className="text-slate-400" />
                  {week}
                </div>

                <div className="space-y-2">
                  {teachers.map((teacher) => {
                    const key = `${section.month}__${week}__${teacher.id}`;
                    const entry = hoursIndex.get(key);

                    return (
                      <div
                        key={key}
                        className="flex items-center justify-between gap-3 rounded-xl border border-slate-200 bg-white px-3 py-2 dark:border-slate-700 dark:bg-slate-900"
                      >
                        <span className="min-w-0 truncate text-xs font-medium text-slate-600 dark:text-slate-300">
                          {getTeacherName(teachers, teacher.id)}
                        </span>

                        {entry ? (
                          <div className="flex shrink-0 items-center gap-2">
                            <span className="text-sm font-bold text-slate-900 dark:text-white">
                              {formatHours(entry.heures)}
                            </span>

                            <button
                              type="button"
                              onClick={() => onEdit(entry)}
                              className="inline-flex h-8 w-8 items-center justify-center rounded-xl text-slate-500 transition hover:bg-slate-100 dark:hover:bg-slate-800"
                              title="Modifier"
                            >
                              <FaEdit />
                            </button>

                            <button
                              type="button"
                              onClick={() => onDelete(entry)}
                              disabled={deletingId === entry.id}
                              className="inline-flex h-8 w-8 items-center justify-center rounded-xl text-rose-600 transition hover:bg-rose-50 disabled:opacity-50 dark:hover:bg-rose-500/10"
                              title="Supprimer"
                            >
                              <FaTrash />
                            </button>
                          </div>
                        ) : (
                          <span className="text-slate-300 dark:text-slate-600">
                            —
                          </span>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </article>
      ))}

      <article className="rounded-2xl border border-slate-200 bg-slate-900 p-4 text-white dark:border-slate-800">
        <p className="text-xs font-bold uppercase tracking-wide text-slate-300">
          Totaux affichés
        </p>

        <div className="mt-3 space-y-2">
          {teachers.map((teacher) => (
            <div
              key={`mobile-total-${teacher.id}`}
              className="flex items-center justify-between gap-3 text-sm"
            >
              <span className="truncate text-slate-300">
                {getTeacherName(teachers, teacher.id)}
              </span>
              <span className="font-bold">
                {formatHours(totalsByTeacher[String(teacher.id)] || 0, true)}
              </span>
            </div>
          ))}
        </div>
      </article>
    </div>
  );
}